import * as moment from 'moment';

const dateConverter = (date) => moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');

export default dateConverter;
